import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";

class OpcionesCarrera extends Component {
    state = {
        title1: "A quienes va dirigida",
        title2: "Oportunidades de trabajo",
        title3: "Competencias del egresado",
        title4: "Plan de estudio",
    }
    render() {
        const { funcion } = this.props;
        const {title1, title2, title3, title4 } = this.state;

        return (
            <div style = {{backgroundColor:"#1e1e1e", paddingLeft: "10%", paddingRight: "10%", paddingTop: "5%", paddingBottom: "5%"}}>
                <Row>
                    <Col md={3}>
                        <div align="center">
                            <div onClick={funcion("item1")} title={title1} style={{cursor: "pointer", backgroundColor:"#1f2f6e", height: 100, width: 100, borderRadius: 50, paddingTop: 35}} >
                                <i className="fa fa-users" style={{fontSize: 30, color: "fff", marginLeft: -10}}></i>
                            </div>
                        </div>
                        <div align="center" style={{color: "#1f2f6e", fontSize: 16}} className="fuente-monserrat custom-mt-10">{title1.toUpperCase()}</div>
                        <div className="custom-mt-10 fuente-monserrat" align="justify" style={{color: "fff"}}>
                            La carrera Publicidad y Mercadeo va dirigida a bachilleres creativos, innovadores, proactivos, dispuestos a asumir retos y... <a title="Mas información" onClick={funcion("item1")} style={{cursor: "pointer", color: "a80012"}}><i className="fa fa-plus-circle"></i> mas</a>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div align="center">
                            <div onClick={funcion("item2")} title={title2} style={{cursor: "pointer", backgroundColor:"#1f2f6e", height: 100, width: 100, borderRadius: 50, paddingTop: 35}} >
                                <i className="fa fa-user-plus" style={{fontSize: 30, color: "fff", marginLeft: -15}}></i>
                            </div>
                        </div>
                        <div align="center" style={{color: "#1f2f6e", fontSize: 14}} className="fuente-monserrat custom-mt-10">{title2.toUpperCase()}</div>
                        <div className="custom-mt-10 fuente-monserrat" align="justify" style={{color: "fff"}}>
                            El profesional egresado de nuestra institución tiene capacidades que le permiten ingresar a un amplio mercado laboral en áreas... <a title="Mas información" onClick={funcion("item2")} style={{cursor: "pointer", color: "a80012"}}><i className="fa fa-plus-circle"></i> mas</a>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div align="center">
                            <div onClick={funcion("item3")} title={title3} style={{cursor: "pointer", backgroundColor:"#1f2f6e", height: 100, width: 100, borderRadius: 50, paddingTop: 35}} >
                                <i className="fa fa-graduation-cap" style={{fontSize: 30, color: "fff", marginLeft: -15}}></i>
                            </div>
                        </div>
                        <div align="center" style={{color: "#1f2f6e", fontSize: 14}} className="fuente-monserrat custom-mt-10">{title3.toUpperCase()}</div>
                        <div className="custom-mt-10 fuente-monserrat" align="justify" style={{color: "fff"}}>
                            El Publicista Mercadologo formado en nuestra institución es un profesional integral, competitivo, capacitado para... <a title="Mas información" onClick={funcion("item3")} style={{cursor: "pointer", color: "a80012"}}><i className="fa fa-plus-circle"></i> mas</a>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div align="center">
                            <div onClick={funcion("planEst")} title={title4} style={{cursor: "pointer", backgroundColor:"#1f2f6e", height: 100, width: 100, borderRadius: 50, paddingTop: 35}} >
                                <i className="fa fa-list" style={{fontSize: 30, color: "fff", marginLeft: -10}}></i>
                            </div>
                        </div>
                        <div align="center" style={{color: "#1f2f6e", fontSize: 16}} className="fuente-monserrat custom-mt-10">{title4.toUpperCase()}</div>
                        <div className="custom-mt-10 fuente-monserrat" align="center" style={{color: "fff"}}>
                            <a className="btn btn-danger fuente-monserrat" href="docs/PlanPublicidadMercadeo.pdf" target="_blank" style={{borderWidth: 1, borderColor:"#a80012", backgroundColor:"#a80012", color:"#FFF"}} title="Descargar el Plan de Estudios">Plan de Estudio <i className="fa fa-download"></i></a>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default OpcionesCarrera;


// WEBPACK FOOTER //
// ./src/site/Componentes/PublicidadMercadeo/OpcionesCarrera.jsx